import React, { useState, useEffect, useContext } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const DashboardLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("tab") || "dashboard"; // Default to Profile
    const [activeTab, setActiveTab] = useState(initialTab);
    const [logo, setLogo] = useState('./logo.png');
    const { user, logout } = useContext(AuthContext);
    const magazine = localStorage.getItem('magazine');
    const handleLogout = () => {
        logout(); // clears token and user
        navigate("/login"); // redirects to login page
    };

    useEffect(() => {
        if (queryParams.get("tab")) {
            setActiveTab(queryParams.get("tab"));
        }

        if (magazine) {
            setLogo(JSON.parse(magazine).magazine_images);
        } else {
            setLogo('./logo.png');
        }

    }, [location, magazine]);

    return (
        <div className="page-wrapper" id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full"
            data-sidebar-position="fixed" data-header-position="fixed">
            <aside className="left-sidebar">
                <div>
                    <div className="brand-logo d-flex align-items-center justify-content-between">
                        <a href="../" className="text-nowrap logo-img pt-2">
                            <img src={(logo)} alt="Logo" className="logo" width={150} />
                        </a>
                        <div className="close-btn d-xl-none d-block sidebartoggler cursor-pointer" id="sidebarCollapse">
                            <i className="ti ti-x fs-8"></i>
                        </div>
                    </div>

                    <nav className="sidebar-nav scroll-sidebar" data-simplebar="">
                        <ul id="sidebarnav">
                            <li className="nav-small-cap">
                                <iconify-icon icon="solar:menu-dots-linear" className="nav-small-cap-icon fs-4"></iconify-icon>
                                <span className="hide-menu">Home</span>
                            </li>
                            <li className="sidebar-item">
                                <a className={(activeTab === "dashboard") ? "active sidebar-link primary-hover-bg " : "sidebar-link primary-hover-bg "}
                                    onClick={() => { setActiveTab("dashboard"); navigate("/dashboard"); }} href={void (0)}>
                                    <iconify-icon icon="solar:atom-line-duotone"></iconify-icon>
                                    <span className="hide-menu">Dashboard</span>
                                </a>
                            </li>
                            <li className="sidebar-item" >
                                <a className={(activeTab === "magazines") ? "active sidebar-link primary-hover-bg " : "sidebar-link primary-hover-bg "}
                                    onClick={() => { setActiveTab("magazines"); navigate("/magazines"); }} href={void (0)}>
                                    <iconify-icon icon="solar:notebook-minimalistic-broken"></iconify-icon>
                                    <span className="hide-menu">Magazines</span>
                                </a>
                            </li>
                            <li className="sidebar-item" >
                                <a className={(activeTab === "releases") ? "active sidebar-link primary-hover-bg indigo-hover-bg " : "sidebar-link primary-hover-bg indigo-hover-bg "}
                                    onClick={() => { setActiveTab("releases"); navigate("/releases"); }} href={void (0)}>
                                    <iconify-icon icon="solar:notebook-minimalistic-broken"></iconify-icon>
                                    <span className="hide-menu">Releases</span>
                                </a>
                            </li>
                            <li className="sidebar-item" >
                                <a className={(activeTab === "statistics") ? "active sidebar-link primary-hover-bg warning-hover-bg " : "sidebar-link primary-hover-bg warning-hover-bg "}
                                    onClick={() => { setActiveTab("statistics"); navigate("/statistics"); }} href={void (0)}>
                                    <iconify-icon icon="solar:chart-2-bold"></iconify-icon>
                                    <span className="hide-menu">Statistics</span>
                                </a>
                            </li>

                            <li className="sidebar-item">
                                <a className={(activeTab === "profile") ? "active sidebar-link primary-hover-bg success-hover-bg " : "sidebar-link primary-hover-bg success-hover-bg "}
                                    onClick={() => { setActiveTab("profile"); navigate("/profile"); }} href={void (0)}>
                                    <iconify-icon icon="solar:user-bold-duotone"></iconify-icon>
                                    <span className="hide-menu">Profile</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <div className="fixed-profile">
                        <div className="card bg-primary-subtle mb-0 shadow-none border-radius-none">
                            <div className="card-body pt-3 pb-3">
                                <div className="d-flex align-items-center justify-content-between gap-3">
                                    {user && (<button className="position-relative btn btn-transparent" onClick={handleLogout}><span>Logout</span>
                                        <iconify-icon icon="solar:logout-line-duotone" className="fs-8"></iconify-icon>
                                    </button>)}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </aside>
            <div className="body-wrapper">
                <div className="body-wrapper-inner">
                    <div className="container-fluid">
                        {/* Tab Content */}
                        <Outlet />
                        <ToastContainer position="top-right" autoClose={2000} />
                    </div>
                </div>
            </div>
        </div>


        // <div className="d-flex">
        //   {/* Sidebar or Navbar */}
        //   <nav className="bg-dark text-white p-3" style={{ width: "220px", height: "100vh" }}>
        //     <h5 className="mb-4">Dashboard</h5>
        //     <ul className="nav flex-column">
        //       <li className="nav-item">
        //         <button className="nav-link btn btn-link text-white" onClick={() => navigate("/dashboard")}>Home</button>
        //       </li>
        //       <li className="nav-item">
        //         <button className="nav-link btn btn-link text-white" onClick={() => navigate("/releases")}>Releases</button>
        //       </li>
        //       <li className="nav-item">
        //         <button className="nav-link btn btn-link text-white" onClick={() => navigate("/statistics")}>Statistics</button>
        //       </li>
        //     </ul>
        //   </nav>

        //   <div className="p-4 flex-grow-1" style={{ width: "100%" }}>
        //     <Outlet />
        //   </div>
        // </div>s
    );
};

export default DashboardLayout;
